export const CAN_VIEW = 'VIEW';
export const CAN_DELETE = 'DELETE';
export const CAN_UPDATE = 'UPDATE';
export const CAN_SIGN = 'SIGN';
export const CAN_EXPORT = 'EXPORT';
export const CAN_ADD = 'ADD';
export const CAN_IMPORT = 'IMPORT';
export const CAN_ASSIGN_PERMISSION = 'ASSIGN_PERMISSION';
export const CAN_ASSIGN_RFID = 'ASSIGN_RFID';
